import { gql } from '@apollo/client';

export const GET_EXTENSIONS = gql`
  query GET_EXTENSIONS(
    $ids: [ID!]
    $projectIds: [ID!]
    $status: [ApplicationStatus!]
  ) {
    extensions(ids: $ids, projectIds: $projectIds, status: $status) {
      id
      date
      newCompletionDate
      justification
      status
    }
  }
`;

export const GET_EXTENSION = gql`
  query GET_EXTENSION(
    $ids: [ID!]
    $projectIds: [ID!]
    $status: [ApplicationStatus!]
  ) {
    extensions(ids: $ids, projectIds: $projectIds, status: $status) {
      id
      date
      project {
        profile {
          lastApprovedCompletionDate
          originalCompletionDate
          deadlineOfUsingUpFunding
        }
      }
      progressReport {
        id
        filename
      }
      supplements {
        id
        filename
      }
      newCompletionDate
      justification
      status
      approvalRoute {
        sequence
        appointedApprover {
          role {
            id
            name
          }
          faculty {
            id
            name
          }
          department {
            id
            name
          }
        }
        approvalSteps {
          sequence
          name
          approverListingType
          appointedApprover {
            role {
              id
              name
            }
            faculty {
              id
              name
            }
            department {
              id
              name
            }
          }
          approver {
            id
            netId
            name
          }
          approved
          comment
          date
        }
      }
    }
  }
`;

export const ADD_EXTENSION = gql`
  mutation AddExtensionMutation($input: AddExtensionInput!) {
    addExtension(input: $input) {
      id
    }
  }
`;

export const UPDATE_EXTENSION = gql`
  mutation UpdateExtensionMutation($input: UpdateExtensionInput!) {
    updateExtension(input: $input) {
      id
    }
  }
`;

export const SUBMIT_EXTENSION = gql`
  mutation SubmitExtensionMutation($input: SubmitExtensionInput!) {
    submitExtension(input: $input) {
      id
    }
  }
`;

export const SUBMIT_EXTENSION_WITH_CUSTOM_DATE = gql`
  mutation SubmitExtensionWithCustomDateMutation(
    $input: SubmitExtensionWithCustomDateInput!
  ) {
    submitExtensionWithCustomDate(input: $input) {
      id
    }
  }
`;

export const CANCEL_EXTENSION = gql`
  mutation CancelExtensionMutation($input: CancelExtensionInput!) {
    cancelExtension(input: $input) {
      id
      status
    }
  }
`;

export const DELETE_EXTENSION = gql`
  mutation DeleteExtensionMutation($input: DeleteExtensionInput!) {
    deleteExtension(input: $input) {
      id
      status
    }
  }
`;

export const APPROVE_EXTENSION = gql`
  mutation ApprvoeExtensionMutation($input: ApproveExtensionInput!) {
    approveExtension(input: $input) {
      id
      status
    }
  }
`;
